import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {Field, FIELD_LABEL_SIZES, FIELD_LABEL_STATES} from '@adv-mt/ui/field'
import {Input, INPUT_SIZES, INPUT_STATES} from '@adv-mt/ui/input'

import {BASE_CLASS, FieldError} from '../ContactForm/FormFields.js'
import {useFieldContext} from './formContexts.js'

const INPUT_SIZE = INPUT_SIZES.L
const FIELD_LABEL_SIZE = FIELD_LABEL_SIZES.S

const errorIdOf = name => `${name}-error`

const TextField = ({
  labelKey,
  placeholderKey,
  errorKey,
  isRequired = false,
  inputProps = {},
  onValueChange,
  onBlur
}) => {
  const {i18n} = useContext(Context)
  const field = useFieldContext()
  const errorId = errorIdOf(field.name)

  return (
    <Field.Root className={`${BASE_CLASS}-field`}>
      <Field.Label
        highlight
        size={FIELD_LABEL_SIZE}
        htmlFor={field.name}
        required={isRequired}
        state={errorKey ? FIELD_LABEL_STATES.ERROR : undefined}
      >
        {i18n.t(labelKey)}
      </Field.Label>
      <Input
        id={field.name}
        name={field.name}
        size={INPUT_SIZE}
        state={errorKey ? INPUT_STATES.ERROR : undefined}
        aria-invalid={errorKey ? true : undefined}
        aria-describedby={errorKey ? errorId : undefined}
        placeholder={placeholderKey ? i18n.t(placeholderKey) : undefined}
        value={field.state.value}
        onValueChange={onValueChange}
        onBlur={onBlur}
        {...inputProps}
      />
      <FieldError id={errorId} errorKey={errorKey} />
    </Field.Root>
  )
}

TextField.displayName = 'ContactFormV2TextField'

TextField.propTypes = {
  labelKey: PropTypes.string.isRequired,
  placeholderKey: PropTypes.string,
  errorKey: PropTypes.string,
  isRequired: PropTypes.bool,
  inputProps: PropTypes.object,
  onValueChange: PropTypes.func,
  onBlur: PropTypes.func
}

export default TextField
